// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b9fc650d","513":"9d3625ad","703":"49f46fe5","787":"9729a9d6"}[chunkId] + ".chunk.js";
};